import React from "react";

type Props = {
  label: string;
  used: number | null | undefined;
  max: number | null | undefined;
};

export default function UsageMeter({ label, used, max }: Props) {
  const safeUsed = typeof used === "number" ? used : 0;
  const safeMax = typeof max === "number" && max > 0 ? max : 0;
  const pct = safeMax > 0 ? Math.min(100, Math.round((safeUsed / safeMax) * 100)) : 0;

  return (
    <div className="mb-4">
      <div className="flex items-baseline justify-between">
        <span className="text-sm text-gray-600 dark:text-gray-300 tracking-wider uppercase">{label}</span>
        <span className="text-sm text-gray-500">{safeUsed}{safeMax ? ` / ${safeMax}` : ""}</span>
      </div>
      <div className="mt-2 h-2 w-full rounded-full bg-gray-200 dark:bg-gray-700 overflow-hidden">
        <div
          className="h-2 rounded-full bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 transition-all"
          style={{ width: `${pct}%` }}
          aria-label={`${label} usage`}
        />
      </div>
    </div>
  );
}
